import { gql } from '@apollo/client';

export const sendOffersToEmail = gql`mutation sendOffersToEmail($soId: String!) {
  sendOffersToEmail(soId: $soId)
}`
